import { BrowserRouter } from "react-router-dom";
import { GlobalContextProvider } from "@/hooks/context";
import { ComponentType, forwardRef } from "react";

export function wrapPage<P extends object>(PageComponent: ComponentType<P>) {
  const Wrapped = forwardRef<unknown, P>((props, ref) => {
    return (
      <BrowserRouter>
        <GlobalContextProvider>
          {/* @ts-expect-error allow ref if PageComponent accepts it */}
          <PageComponent ref={ref} {...props} />
        </GlobalContextProvider>
      </BrowserRouter>
    );
  });

  Wrapped.displayName = `Wrapped(${PageComponent.displayName || PageComponent.name || "Component"})`;
  return Wrapped;
}
